import React from 'react';

interface PriorityBadgeProps {
    priorityStatus: number | false | null | undefined;
    loading?: boolean;
}

const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priorityStatus, loading = false }) => {
    if (loading && (priorityStatus === null || priorityStatus === undefined)) {
        return (
            <span className="inline-flex items-center px-1 py-0.5 rounded text-[8px] font-bold bg-gray-100 text-gray-300 border border-gray-200 animate-pulse w-fit">
                P?
            </span>
        );
    }

    if (priorityStatus === 0) {
        return (
            <span className="inline-flex items-center px-1 py-0.5 rounded text-[8px] font-bold bg-red-100 text-red-600 border border-red-300 w-fit">
                ⭐P0
            </span>
        );
    }

    if (priorityStatus === 1) {
        return (
            <span className="inline-flex items-center px-1 py-0.5 rounded text-[8px] font-bold bg-orange-100 text-orange-600 border border-orange-300 w-fit">
                🌟P1
            </span>
        );
    }

    return null;
};

export default PriorityBadge;
